import * as R from "ramda";
import { REF_AREA_ROLES, REF_AREA_IDS } from "./constants/dimensions.mjs";
const isRefAreaDimension = (dimension) => {
  const hasRefAreaDimensionRole = R.includes(
    R.prop("role", dimension),
    REF_AREA_ROLES
  );
  if (hasRefAreaDimensionRole) {
    return true;
  }
  return R.includes(R.prop("id", dimension), REF_AREA_IDS);
};
export {
  isRefAreaDimension
};
